import React, { ReactElement } from "react";
import { IconProps } from "../types";

export const TakafulTick = ({ className }: IconProps): ReactElement => {
  return (
    <svg
      className={`svg-icon ${className}`}
      fill="currentColor"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 1024 1024"
    >
      <path
        fill="#950f1d"
        d="M0 552.387c4.894-84.825 44.86-163.942 110.11-217.774l158.232 208.801-160.679 145.183-87.272-72.591-20.391-63.619z"
      ></path>
      <path
        fill="#e91431"
        d="M1021.987 284.044c3.262 4.078 2.447 10.603-1.631 13.866 0 0 0 0 0 0v0l-23.653 17.129-36.703 26.916-47.307 35.072-249.583 183.517-67.698 48.122c-21.207 15.497-42.413 29.363-63.619 44.86-19.575 13.866-34.256 25.285-53.016 39.15-16.313 12.234-37.519 28.547-53.832 40.782l-39.966 29.363c-28.547 23.653-61.172 42.413-97.060 53.832-14.681 4.078-29.363 6.525-44.86 8.156-17.129 1.631-34.256 0.816-51.385-2.447-17.944-4.078-36.703-10.603-53.016-20.391-19.575-11.419-37.519-26.1-52.2-43.229-18.76-22.022-34.256-47.307-45.676-73.407-15.497-35.072-27.731-72.591-35.888-110.11-1.631-8.156-3.262-15.497-4.894-23.653 0 0 18.76 104.401 168.020 34.256l0.816-0.816 559.523-352.353c96.245-61.172 223.483-38.335 293.627 51.385v0z"
      ></path>
      <path
        fill="#71070a"
        d="M51.385 605.403v0c-1.631-0.816-3.262-0.816-4.894-1.631l-1.631-0.816-4.078-0.816-4.894-2.447-1.631-1.631c-0.816 0-1.631-0.816-3.262-1.631l-1.631-0.816c-0.816-0.816-1.631-1.631-2.447-1.631l-6.525-6.525c0 0 0 0 0-0.816l-0.816-0.816c-1.631-0.816-3.262-2.447-4.078-4.078l-0.816-0.816c-1.631-1.631-2.447-3.262-3.262-4.894 0 0 0 0 0-0.816l-1.631-1.631c-0.816-1.631-1.631-3.262-2.447-4.894l-0.816-2.447c-0.816-0.816-0.816-2.447-1.631-3.262l-0.816-1.631v0.816c-0.816-1.631-1.631-3.262-2.447-4.894s-0.816-2.447-1.631-4.078v0.816c3.262 14.681 5.709 27.731 8.972 40.782l8.972 12.234 32.625 97.060c2.447 4.894 4.894 8.972 7.34 13.050l1.631 3.262c1.631 3.262 4.078 6.525 5.709 9.787s3.262 4.894 4.894 7.34c1.631 2.447 3.262 4.894 4.894 7.34 3.262 4.078 5.709 8.156 8.972 11.419 0.816 0.816 1.631 2.447 2.447 3.262l185.964 61.172c4.894-0.816 9.787-2.447 14.681-3.262 33.441-11.419 64.435-28.547 92.167-50.569l4.078-3.262c0 0 0 0 0 0s0 0 0 0l39.966-29.363c16.313-12.234 37.519-28.547 53.832-40.782 15.497-11.419 27.731-20.391 41.597-30.994l1.631-0.816c-328.7 27.731-411.078-22.022-468.988-56.278z"
      ></path>
      <path
        fill="#5b090e"
        d="M276.499 819.914c-119.083-45.676-216.142-135.395-269.974-252.030-2.447-4.894-4.894-10.603-5.709-16.313 52.2 270.79 191.674 287.102 275.684 268.343z"
      ></path>
    </svg>
  );
};
